import * as yaml from 'js-yaml';
import type { ArchiGraphDocument, ArchiGraphSchema, ResolvedSchema } from './types';

export function parseDocument(content: string): ArchiGraphDocument {
  const doc = yaml.load(content) as ArchiGraphDocument;
  if (!doc || typeof doc !== 'object') throw new Error('Invalid YAML document');
  if (!doc.archigraph) throw new Error('Missing "archigraph" version field');
  doc.nodes = doc.nodes || [];
  doc.edges = doc.edges || [];
  doc.views = doc.views || [];
  return doc;
}

export function parseSchema(content: string): ArchiGraphSchema {
  const raw = yaml.load(content) as ArchiGraphSchema;
  if (!raw || typeof raw !== 'object') throw new Error('Invalid schema YAML');
  if (!raw.layers) throw new Error('Schema missing "layers"');
  raw.nodeKinds = raw.nodeKinds || {};
  raw.edgeKinds = raw.edgeKinds || {};
  return raw;
}

export function resolveSchema(schema: ArchiGraphSchema): ResolvedSchema {
  const layers: ResolvedSchema['layers'] = {};
  for (const [id, def] of Object.entries(schema.layers)) {
    layers[id] = {
      id,
      label: def.label || formatLabel(id),
      order: def.order || 0,
      ui: { color: def.ui?.color || '#666666' },
    };
  }

  const nodeKinds: ResolvedSchema['nodeKinds'] = {};
  for (const [id, def] of Object.entries(schema.nodeKinds)) {
    nodeKinds[id] = {
      id,
      label: def.label || formatLabel(id),
      recursive: def.recursive === true,
      implementable: def.implementable === true,
      ui: {
        shape: def.ui?.shape || 'ellipse',
        color: def.ui?.color || '#666666',
      },
    };
  }

  const edgeKinds: ResolvedSchema['edgeKinds'] = {};
  for (const [id, def] of Object.entries(schema.edgeKinds)) {
    edgeKinds[id] = {
      id,
      label: def.label || formatLabel(id),
      ui: { color: def.ui?.color || '#888888' },
    };
  }

  return { layers, nodeKinds, edgeKinds };
}

function formatLabel(id: string): string {
  return id.split(/[._-]/).map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(' ');
}
